import { type SimilarProduct } from '@/modules/similar/aliases';

export function getSizeNames(sizes: SimilarProduct['sizes']): string[] {
  return sizes?.flatMap((variant) => variant.name ?? []) ?? [];
}
